
define('template!anaAssayCreateEditLayoutTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="detailed-info-form-container">\n  <div class="saving-label"></div>\n  <div class="error-label">' +
((__t = ( _.i18n('common.serverError') )) == null ? '' : __t) +
'\n      <div class="error-msg">  </div>\n  </div>\n  <div class="form-horizontal">\n    <div class="form-inputs-container">\n      ';
 if (fromLmbAna) { ;
__p += '\n        <div class="form-group" data-field-name="refAssay">\n          <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('anaassay.refAssay') )) == null ? '' : __t) +
'</label>\n          <div class="col-xs-9">\n            <div class="js-select-assay-region"></div>\n          </div>\n        </div>\n      ';
 } else { ;
__p += '\n        <div class="form-group" data-field-name="refLmbAna">\n          <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('anaassay.refLmbAna') )) == null ? '' : __t) +
'</label>\n          <div class="col-xs-9">\n            <div class="js-select-lmbana-region"></div>\n          </div>\n        </div>\n      ';
 } ;
__p += '\n      <div class="form-group" data-field-name="nbRepetition">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('anaassay.nbRepetition') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="number" class="form-control floating-label js-info-input" data-field-name="nbRepetition"\n                 placeholder="' +
((__t = ( _.i18n('anaassay.nbRepetition') )) == null ? '' : __t) +
'" value="' +
((__t = ( nbRepetition )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="form-group" data-field-name="comment">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.comment') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <textarea class="form-control floating-label js-info-input" rows="4" data-field-name="comment" placeholder="' +
((__t = ( _.i18n('common.comment') )) == null ? '' : __t) +
'">' +
((__t = ( comment )) == null ? '' : __t) +
'</textarea>\n        </div>\n      </div>\n      <div class="row">\n        <div class="pull-right p-r-15">\n          <button class="btn btn-default btn-flat cancel-b js-cancel-popup">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n          <button disabled class="btn btn-primary disabled-grey js-confirm">' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

